import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pt-br";
import { pdf } from "@react-pdf/renderer";
import { useEffect, useState } from "react";

import api from "../../services/api";

import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { useTheme } from "@mui/system";
import { PageTemplateEasyReport } from "../generateReport";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);
dayjs.locale("pt-br");

export default function RelatorioRfoPdfEmail() {
  // Obter dados da URL
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dadosString = searchParams.get("dados");
  const dadosDecodificados = JSON.parse(decodeURIComponent(dadosString));
  // States
  const [blobString, setBlobString] = useState(null);
  const [triggered, setTriggered] = useState(false);
  // Estilos
  const theme = useTheme();

  useEffect(() => {
    if (!triggered) {
      handleDados();
      setTriggered(true);
    }
  }, []);

  // Gerar relatório
  const handleDados = async () => {
    try {
      // Obter configurações de cabeçalho
      const config = await api.post("/find/generalSetting", {
        product: "usageReport",
      });

      const logo = config?.data?.imagem
        ? await handleUrlToBase64({ url: config?.data?.imagem })
        : null;
      const generalSettings =
        Object.keys(config?.data)?.length > 0
          ? {
              logo: logo,
              ...config?.data,
            }
          : {};
      // Obter json do relatório gerado
      const report = await api.post("/find/historyReport", {
        id: dadosDecodificados?.id,
      });

      const selectPages = {
        teoric: false,
        sla: false,
        onu: false,
        rfo: true,
      };

      // Criar arquivo PDF
      const MyDoc = (
        <PageTemplateEasyReport
          relatorio={{
            source: `Monitoramento ${
              window?.config?.REACT_APP_NAME_ENTERPRISE ||
              process.env.REACT_APP_NAME_ENTERPRISE
            }`,
            createdAt: dayjs().tz("America/Sao_Paulo"),
            dataInicial: report?.data?.initialDate,
            dataFinal: report?.data?.finalDate,
            client:
              report?.data?.cliente?.razaoSocial ||
              report?.data?.cliente?.nomeFantasia ||
              "",
          }}
          enterpriseConfig={{ ...generalSettings }}
          selectPages={selectPages}
          rfos={report?.data?.rfos || []}
          totalTickets={report?.data?.totalTickets || 0}
        />
      );

      // Gerar o PDF como Blob e converter para base64
      const blob = await pdf(MyDoc).toBlob();
      const blobAsBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result.split(",")[1];
          resolve(base64data);
        };
        reader.readAsDataURL(blob);
      });

      setBlobString(blobAsBase64);
    } catch (error) {
      console.error(error);
    }
  };

  async function handleUrlToBase64({ url, options = {} }) {
    try {
      const response = await api.post("/cliente/relatorio/urlToImageBase64", {
        url,
        options,
      });

      if (response.data) {
        return response?.data;
      }
    } catch (error) {
      console.error("Error: ", error);
      return null;
    }
  }

  return (
    <>
      <Box id="pdf">{blobString && blobString}</Box>
    </>
  );
}
